export default __webpack_public_path__ + "static/media/sab1.28eca4df.jpg";